export default __webpack_public_path__ + "static/google-play-download@2x-c38dedb745c0b0c196806f0c8b6cc3f5.png";